import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationRegionalUIHelpers";

const OrganizationRegionalUIContext = createContext();

export function useOrganizationRegionalUIContext() {
  return useContext(OrganizationRegionalUIContext);
}

export const OrganizationRegionalUIConsumer =
  OrganizationRegionalUIContext.Consumer;

export function OrganizationRegionalUIProvider({
  organizationRegionalUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganizationRegional = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganizationRegional,
    newOrganizationRegionalButtonClick:
      organizationRegionalUIEvents.newOrganizationRegionalButtonClick,
    openEditOrganizationRegionalPage:
      organizationRegionalUIEvents.openEditOrganizationRegionalPage,
    openOrganizationRegionalFilePage:
      organizationRegionalUIEvents.openOrganizationRegionalFilePage
  };

  return (
    <OrganizationRegionalUIContext.Provider value={value}>
      {children}
    </OrganizationRegionalUIContext.Provider>
  );
}
